export default "__VITE_ASSET__b51c2c27__"